import { render, staticRenderFns } from "./company-information-card.vue?vue&type=template&id=769c15a0&scoped=true&"
import script from "./company-information-card.vue?vue&type=script&lang=js&"
export * from "./company-information-card.vue?vue&type=script&lang=js&"
import style0 from "./company-information-card.vue?vue&type=style&index=0&id=769c15a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c15a0",
  null
  
)

export default component.exports